import React from "react";
import "./About.scss";
import about from "../assets/about.jpg";

const About = () => {
  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="hero-content">
            <h1>About Swarna Shringar</h1>
            <p>
              Crafting timeless elegance through exquisite artificial jewelry
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="story section">
        <div className="container">
          <div className="story-content">
            <div className="story-text">
              <h2>Our Story</h2>
              <p>
                Founded with a passion for timeless beauty, Swarna Shringar
                began its journey just a year ago — with a heartfelt vision to
                bring luxury, elegance, and confidence to every woman, without
                compromising on quality or style.
              </p>
              <p>
                At Swarna Shringar, we believe that jewelry is more than an
                accessory — it’s a story, a memory, a celebration of womanhood.
                Each piece is thoughtfully designed and lovingly handcrafted by
                our skilled artisans, who pour their heart and soul into
                creating jewelry that becomes a part of your journey. From
                traditional designs that honor our cultural heritage to
                contemporary pieces that reflect the modern woman’s charm, our
                collection celebrates the true essence of feminine beauty.
              </p>
              <p>
                In just one year, Swarna Shringar has grown into a trusted
                choice for many women who value quality, creativity, and
                elegance. We are grateful for every customer who has supported
                us and become part of our growing family.
              </p>
              <p>
                Every piece is designed to elevate your style and reflect the
                powerful woman you are.
              </p>
            </div>
            <div className="story-image">
              <img src={about} alt="Swarna Shringar" />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values section section-light">
        <div className="container">
          <div className="section-header">
            <h2>Our Values</h2>
            <p>The principles that guide everything we do</p>
          </div>

          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              </div>
              <h3>Quality First</h3>
              <p>
                We use only the finest materials and techniques to ensure every
                piece meets our high standards of excellence.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <circle cx="12" cy="12" r="10" />
                  <polyline points="12,6 12,12 16,14" />
                </svg>
              </div>
              <h3>Timely Delivery</h3>
              <p>
                We understand the importance of special occasions and ensure
                your jewelry arrives when you need it most.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                </svg>
              </div>
              <h3>Customer Care</h3>
              <p>
                Our dedicated support team is here to help you find the perfect
                piece and ensure your complete satisfaction.
              </p>
            </div>

            <div className="value-card">
              <div className="value-icon">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                </svg>
              </div>
              <h3>Innovation</h3>
              <p>
                We continuously explore new designs and techniques to bring you
                fresh, modern jewelry collections.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="process section">
        <div className="container">
          <div className="section-header">
            <h2>Our Process</h2>
            <p>From concept to creation, here's how we craft your jewelry</p>
          </div>

          <div className="process-steps">
            <div className="process-step">
              <div className="step-number">01</div>
              <h3>Design & Planning</h3>
              <p>
                Our designers create detailed blueprints and select the perfect
                materials for each piece.
              </p>
            </div>

            <div className="process-step">
              <div className="step-number">02</div>
              <h3>Material Selection</h3>
              <p>
                We carefully choose high-quality materials that ensure
                durability and beauty.
              </p>
            </div>

            {/* <div className="process-step">
              <div className="step-number">03</div>
              <h3>Crafting</h3>
              <p>
                Skilled artisans bring the design to life with precision and
                attention to detail.
              </p>
            </div> */}

            <div className="process-step">
              <div className="step-number">03</div>
              <h3>Quality Check</h3>
              <p>
                Each piece undergoes rigorous quality inspection before
                packaging.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      {/* <section className="team section section-light">
        <div className="container">
          <div className="section-header">
            <h2>Meet Our Team</h2>
            <p>The talented individuals behind our beautiful jewelry</p>
          </div>
          
          <div className="team-grid">
            <div className="team-member">
              <div className="member-photo">
                <img 
                  src="https://images.unsplash.com/photo-1494790108755-2616b612b786?w=300&h=300&fit=crop&crop=face" 
                  alt="Priya Sharma"
                />
              </div>
              <h3>Priya Sharma</h3>
              <p className="member-role">Founder & Lead Designer</p>
              <p className="member-bio">With 15 years of experience in jewelry design, Priya brings creativity and passion to every collection.</p>
            </div>
            
            <div className="team-member">
              <div className="member-photo">
                <img 
                  src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=300&h=300&fit=crop&crop=face" 
                  alt="Rajesh Kumar"
                />
              </div>
              <h3>Rajesh Kumar</h3>
              <p className="member-role">Master Craftsman</p>
              <p className="member-bio">Rajesh's skilled hands have been creating beautiful jewelry pieces for over 20 years.</p>
            </div>
            
            <div className="team-member">
              <div className="member-photo">
                <img 
                  src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=300&h=300&fit=crop&crop=face" 
                  alt="Sneha Patel"
                />
              </div>
              <h3>Sneha Patel</h3>
              <p className="member-role">Quality Manager</p>
              <p className="member-bio">Sneha ensures every piece meets our exacting standards before it reaches our customers.</p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Stats Section */}
      {/* <section className="stats section section-dark">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">20+</div>
              <div className="stat-label">Years of Experience</div>
            </div>
            
            <div className="stat-item">
              <div className="stat-number">50K+</div>
              <div className="stat-label">Happy Customers</div>
            </div>
            
            <div className="stat-item">
              <div className="stat-number">1000+</div>
              <div className="stat-label">Unique Designs</div>
            </div>
            
            <div className="stat-item">
              <div className="stat-number">99%</div>
              <div className="stat-label">Customer Satisfaction</div>
            </div>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default About;
